import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';

import { MetaService } from '../../meta.service';
import { ScrollService } from '../../scroll.service';
import { Project } from '../project.model';
import { ProjectService } from '../project.service';

@Component({
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.min.css'],
})
export class ProjectDetailComponent implements OnInit {
    public project: Project;
    public isLoaded = false;

    public constructor(private route: ActivatedRoute,
                       private router: Router,
                       private metaService: MetaService,
                       private projectService: ProjectService,
                       public scrollService: ScrollService) {
    }

    ngOnInit() {
        this.route.paramMap
            .switchMap(params => this.projectService.getProjectBySlug(params.get('id')))
            .subscribe(project => {
                if (project === undefined) {
                    this.router.navigate(['/404']);
                    return;
                }

                this.metaService.updateMetaSettings({
                    description: project.description,
                    image: `${window.location.origin}/assets/project-images/${project.image}`,
                    pageTitle: project.title,
                    title: project.title,
                });
                this.project = project;
                this.isLoaded = true;
            });
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/detail/detail.component.ts